import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from '@apollo/client';
import { makeDecodedQuery } from '@infl-ts/util-make-apollo-decoded';
import * as t from 'io-ts';
import { MemberQuery } from './codecs';
export var ProfilePopoverMember = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query ProfilePopoverMember($memberId: ID!) {\n    member: node(id: $memberId) {\n      ... on Member {\n        id\n        name\n        title\n        company\n        level {\n          name\n        }\n        avatarUrl\n        isAdmin\n      }\n    }\n    currentUser: profile {\n      id\n      isAdmin\n    }\n  }\n"])));
export var useProfilePopoverMember = makeDecodedQuery(ProfilePopoverMember, MemberQuery, t.type({
  memberId: t.string
}));